import { handleError } from './error';

export const getUserLocation = async () => {
  try {
    const response = await fetch('https://ipapi.co/json/');

    if (!response.ok) {
      throw new Error(`Failed to fetch user location: ${response.status}`);
    }

    const {
      country_name: countryName,
      region,
      city,
    } = await response.json();

    return {
      countryName,
      region,
      city,
    };
  } catch (error) {
    handleError({
      error,
      message: 'Error in the getPersonCountry function',
    });
  }
};
